import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { ButtonBase, CircularProgress, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Row } from '../Layout';
import TableActions, { ActionsProps } from './TableActions';
import { RowBase } from './types';

type RowActionsContentProps<T extends RowBase> = {
  row: T;
  hasPendingAction: boolean;
  actions?: ActionsProps<T>['actions'];
  handleIcon?: OverridableComponent<SvgIconTypeMap<object>>;
  canExpand: boolean;
  isExpanded: boolean;
  onRowExpand?: (row: T) => void;
  withDividers?: boolean;
};

const RowActionsContent = <T extends RowBase>({
  row,
  hasPendingAction,
  actions,
  handleIcon,
  canExpand,
  isExpanded,
  onRowExpand,
  withDividers,
}: RowActionsContentProps<T>): JSX.Element => (
  <Row spacing="xs" centered>
    {hasPendingAction ? <CircularProgress size={15} /> : null}
    <TableActions
      actions={actions}
      row={row}
      handleIcon={handleIcon}
      withDividers={withDividers}
    />
    {onRowExpand && canExpand ? (
      <ButtonBase
        onClick={(e) => {
          e.stopPropagation();
          onRowExpand(row);
        }}
      >
        {isExpanded ? (
          <ExpandLess fontSize="small" />
        ) : (
          <ExpandMore fontSize="small" />
        )}
      </ButtonBase>
    ) : null}
  </Row>
);

export default RowActionsContent;
